import RssTableContainer from './RssTableContainer';

export default RssTableContainer;
